<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Languages" class="d-icon d-icon--languages" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 1a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 3 1Z"/><path d="M2.146 3.646a.5.5 0 0 1 .708 0l.896.897.861-.862L5.066 3H1a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1h-.732l-.852 1.277a.5.5 0 0 1-.062.077l-.897.896 1.397 1.396a.5.5 0 1 1-.708.708L3.75 5.957 2.354 7.354a.5.5 0 1 1-.708-.708L3.043 5.25l-.897-.896a.5.5 0 0 1 0-.708Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 5.5a.5.5 0 0 1 .447.276l2.5 5a.5.5 0 1 1-.894.448L9.69 9.5H7.309l-.862 1.724a.5.5 0 1 1-.894-.448l2.5-5A.5.5 0 0 1 8.5 5.5Zm-.691 3L8.5 7.118 9.191 8.5H7.809Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLanguages',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
